// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 

import { Browser } from "@lib/browser/Browser";
import { getDmsDetectionUrls } from "@lib/utilities/DmsDetectionUrlProvider";
import {LogManager} from "@lib/logging/LogManager";

//UsedImplicitly by js code
export async function reloadANTabs() {
  const log = LogManager.createLog("TabReloadHelper");
  try {
    const patterns = await getDmsDetectionUrls();
    const dmsInitTabs = (await Promise.all(patterns.map(async pattern => await Browser.tabs.query({url: pattern}))))
      .reduce((acc, value) => acc.concat(value), []);

    for (let tab of dmsInitTabs) {
      if (tab.windowId != null) {
        const window = await Browser.windows.get(tab.windowId);
        Browser.windows.update(window.id, {focused: true, drawAttention: true});

        if (tab.id) {
          Browser.tabs.reload(tab.id);
        }
      }
    }
  } catch (e) {
    log.error("Error trying to reload dms tabs during installation: %o", e);
  }
}